import React, { memo } from "react";

import { Localized } from "fluent-react/compat";

const Button = memo(
  ({
    containerButton = "",
    translation = "",
    buttonClass = "",
    variables = "",
    sendData,
    hour = "",
  }) => {
    return (
      <div className={`container-button ${containerButton}`}>
        <span
          className={`button-global-arround ${buttonClass}`}
          onClick={(e) => {
            e.preventDefault();
            sendData(variables);
          }}
        >
          <Localized id={translation} />
          {hour ? <span className="isNumber isMedBold"> ({hour})</span> : ""}
        </span>
      </div>
    );
  }
);

export default Button;
